<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1" style="display: flex;">{{ $t('Išrašų užsakymai') }}<el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Išrašų užsakymai" mainTitle></el-tooltip></h1>
    <!-- add button  -->
    <el-button
      class="mb-5"
      color="primary"
      icon="pridėti"
      title="Užsakyti išrašą"
      :loading="loading"
      @click.native.stop="newItem()"
    />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header-sav"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :item-class="rowClass"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal')
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->
      <template #[`item.type`]="{ item }">
        <el-table-enum enumName="dataVolumeOrderSav" :item="item.type" />
      </template>
      <template #[`item.status`]="{ item }">
        <div style="inline-size: max-content;">
        <el-table-enum enumName="StatementStatus" :item="item.status" />
        </div>
      </template>
      <template #[`item.purpose`]="{ item }">
        <el-table-download
          :title="item.purpose"
          :file="item.purpose_file"
        ></el-table-download>
      </template>
      <template #[`item.legal_basis`]="{ item }">
        <el-table-download
          :title="item.legal_basis"
          :file="item.legal_basis_file"
        ></el-table-download>
      </template>

      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="setItem(item)"
            fakeStatus
            @fakeStatusItem="fakeStatusItem(item)"
            @deleteItem="deleteItem(item)"
            @viewItem="viewItem(item)"
            @downloadItem="download(item)"
            @addToCartItem="addToCart(item)"
            @goToCartItem="goToCart(item)"
          />
        </div>
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <modal-delete
      title="Šalinti įrašą"
      text="Ar tikrai norite pašalinti įrašą?"
      v-model="showDelete"
      :loading="loading"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
     <modal-order-view
      v-if="showOrderView"
      v-model="showOrderView"
      :loading="loading"
      :id="modalOrderViewId"
    />
  </v-container>
</template>

<script>
import userRole from '@/mixins/userRole'
import ModalDelete from '@/components/modals/ModalDelete'
import ModalOrderView from '@/components/modals/ModalOrderView'
import math from '@/mixins/math'
import { mapGetters } from 'vuex'

export default {
  name: 'Orders',
  components: {
    ModalDelete,
    ModalOrderView,
  },
  mixins: [userRole, math],
  data() {
    return {
      pageloading: true,
      loading: false,
      cartLoading: false,
      paginationloading: false,
      search: null,
      showDelete: false,
      modalDeleteItem: null,
      showOrderView: false,
      modalOrderViewId: null,
      listData: [],

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 10,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    ...mapGetters(['listParams','menuState']),
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
          {
          text: this.$t('Išrašo užsakymo numeris'),
          align: 'start',
          value: 'number',
          width: '10rem',
        },
          {
          text: this.$t('Užsakymo data ir laikas'),
          align: 'start',
          value: 'receive_date',
          width: '10rem',
        },
        // {
        //   text: this.$t('Duomenų apimtis'),
        //   align: 'start',
        //   value: 'type',
        // },
        // {
        //   text: this.$t('Duomenų naudojimo tikslas'),
        //   align: 'start',
        //   value: 'purpose',
        // },
        // {
        //   text: this.$t('Teisinis pagrindas'),
        //   align: 'start',
        //   value: 'legal_basis',
        // },
        {
          text: this.$t('Būsena'),
          align: 'start',
          value: 'status',
        },
        {
          text: this.$t('Būsenos data ir laikas'),
          align: 'start',
          value: 'status_date',
          width: '9rem',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  beforeDestroy() {},
  created() {
    this.isMenuState()
    this.setlistParams()
  },
  methods: {
     setItem(item){
      return item
    },
     isMenuState(){
      if(this.menuState == 'show_all_without_statements'){
        this.$router.push({
          name: 'savInfoPage',
          params: {
            type: 'showOnlyStatements',
          },
        })
      }
    },
    setlistParams(){
      if (this.listParams && (this.pagination.pageSize != this.listParams.pageSize) && (this.listParams.pageSize != null)) {
        this.pagination.pageSize = this.listParams.pageSize
      } 
    },
    newItem() {
      this.$router.push({
        name: 'savNewOrder',
      })
    },
    getData(resetPageNr = false) {
      if(this.menuState == 'show_all_without_statements'){
        return
      }
      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
      }

      this.$axios
        .post(`statement-orders/list`, data)
        .then((res) => {
          this.listData = res.data.statementOrders
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
          pageSize: pagination.itemsPerPage,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    // goToCart(item){
    //   const url = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}basketDetails.do?basketId=${item.cart_id}&returnUrl=basketList.do`
    //   window.location.href = url
    // },
    goToCart(item){
      if (this.cartLoading == false) {
        this.cartLoading = true;
        this.$axios
        .post(`statement-orders/${item.id}/cartId`)
        .then((res) => {
            let cartId = res.data.cart_id
            let url = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}basketDetails.do?basketId=${cartId}&returnUrl=basketList.do`
            window.location.href = url
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.cartLoading = false
        })
      }
    },
    addToCart(item) {
      if (this.cartLoading == false) {
        this.cartLoading = true;
        this.$axios
        .post(`statement-orders/${item.id}/cartId`)
        .then((res) => {
            let cartId = res.data.cart_id
            let url = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}basketDetails.do?basketId=${cartId}&returnUrl=basketList.do`
            window.location.href = url
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.cartLoading = false
        })
      }
    },
    download(item) {
      this.loading = true
      this.$axios
        .get(`uploads/${item.upload_id}/download`)
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    
    fakeStatusItem(item) {
      let url = `local/statement-orders/${item.id}/fake-payment`
      this.$axios
        .post(url)
        .then((res) => {
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    viewItem(item) {
      this.modalOrderViewId = item.id
      this.showOrderView = true
    },
    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`statement-orders/${item.id}`)
        .then((res) => {
          this.$root.$emit('DATA_OK_CODE', '000111')
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.showDelete = false
        })
    },

    rowClass(item) {
      if (item.status === 'warning') {
        return `status-warning`
      }
      if (item.status === 'outdate') {
        return `status-outdate`
      }
      if (item.status === 'repost') {
        return `status-repost`
      }
      return ''
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
